"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoLicenseUrl = void 0;
const utils_1 = require("../utils");
exports.InfoLicenseUrl = () => {
    return {
        License(license, ctx) {
            utils_1.validateDefinedAndNonEmpty('url', license, ctx);
        },
    };
};
